import { render, staticRenderFns } from "./CoilsDesignDetails.vue?vue&type=template&id=60b836f0&"
import script from "./CoilsDesignDetails.vue?vue&type=script&lang=js&"
export * from "./CoilsDesignDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports